import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Lock, ArrowRight, UserPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LoginModal = () => {
  const { isLoginModalOpen, closeLoginModal } = useAuth();
  const navigate = useNavigate();

  if (!isLoginModalOpen) return null;

  const handleAction = (path) => {
    closeLoginModal();
    navigate(path);
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
        {/* Backdrop */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeLoginModal}
          className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        />

        {/* Modal Content */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          className="relative w-full max-w-md bg-white rounded-[2.5rem] shadow-2xl overflow-hidden p-8 lg:p-10"
        >
          {/* Close Button */}
          <button
            onClick={closeLoginModal}
            className="absolute top-6 right-6 p-2 rounded-full hover:bg-slate-50 text-slate-400 transition-colors"
          >
            <X size={20} />
          </button>

          {/* Branding/Icon */}
          <div className="w-16 h-16 bg-blue-50 rounded-3xl flex items-center justify-center mb-8">
            <Lock className="text-blue-600" size={32} />
          </div>

          <div className="space-y-2 mb-10">
            <h2 className="text-3xl font-black text-slate-900 leading-tight">Login Required</h2>
            <p className="text-slate-500 font-medium">Please sign in to your account to save items to your favorites or add them to your cart.</p>
          </div>

          <div className="space-y-4">
            <button
              onClick={() => handleAction('/auth')}
              className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black shadow-xl shadow-blue-200 hover:bg-blue-700 transition-all flex items-center justify-center gap-3 active:scale-[0.98]"
            >
              Sign In to Account
              <ArrowRight size={20} />
            </button>
            <button
              onClick={() => handleAction('/auth?mode=signup')}
              className="w-full py-4 bg-white border-2 border-slate-100 text-slate-900 rounded-2xl font-black hover:bg-slate-50 transition-all flex items-center justify-center gap-3 active:scale-[0.98]"
            >
              <UserPlus size={20} className="text-blue-600" />
              Create New Account
            </button>
          </div>

          <p className="mt-8 text-center text-xs font-black uppercase tracking-widest text-slate-300">
            Secure Enterprise Shopping
          </p>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default LoginModal;
